import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";

export const valuationEventGridColumns: PolluxGridConfig[] = [
  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: "projectValuation.projectName",
    field: "ProjectName",
    width: 200
  },
  {
    title: "projectValuation.valuationPortfolioName",
    field: "ValuationPortfolioName",
    width: 300
  },
  {
    title: "projectValuation.reportDate",
    field: "ReportDate",
    type: "date",
    width: 200
  },
  {
    title: "projectValuation.businessLineNrId",
    field: "BusinessLineNrIdDescription",
    width: 200
  },
  {
    title: "projectValuation.clientManual",
    field: "ClientManual",
    width: 200
  },
  {
    title: "projectValuation.valuationDate",
    field: "ValuationDate",
    type: "date",
    width: 200
  },
  {
    title: "projectValuation.numberOfPropertiesManually",
    field: "NumberOfPropertiesManually",
    type: "special",
    width: 200
  },
  {
    title: "projectValuation.volumeOfValuation",
    field: "VolumeOfValuation",
  type: "currency",
    width: 200
  },
  {
    title: "projectValuation.liabilityTypeId",
    field: "LiabilityTypeIdDescription",
    width: 200
  },
  {
    title: "projectstd.status",
    field: "ProjectStatusDescription",
    width: 200
  },
  {
    title: "projectValuation.deadlineDraft",
    field: "deadlineDraft",
    type: "date",
    width: 200
  },
  {
    title: "projectValuation.deadlineFinal",
    field: "deadlineFinal",
    type: "date",
    width: 200
  },
  {
    title: "projectValuation.languageId",
    field: "LanguageIdDescription",
    width: 200
  },
  {
    title: "projectValuation.templateId",
    field: "TemplateIdDescription",
    width: 200
  },
  {
    title: "report.publishStatus",
    field: "PublishStatusId",
    type: "special",
    width: 135,
    cellClass: "publish-status-field"
  },
  {
    title: "report.lastPrintRequest",
    field: "LastPrintRequestDate",
    type: "date",
    width: 250
  },
  {
    title: "projectValuation.remark",
    field: "Remark",
    width: 200
  },
  {
    title: "projectValuation.projectID",
    field: "ProjectID",
    width: 200
  },
  {
    title: "projectValuation.periodOfValuationID",
    field: "PeriodOfValuationIDDescription",
    width: 200
  },
  {
    title: "projectValuation.oid",
    field: "Oid",
    width: 200
  },
  {
    title: "projectValuation.periodeOfValuationUID",
    field: "PeriodeOfValuationUID",
    width: 220
  },
  {
    title: "projectValuation.dateCreated",
    field: "DateCreated",
    type: "date",
    width: 200
  },
  {
    title: "projectValuation.ownerUserID",
    field: "OwnerUserIDDescription",
    width: 200
  },
  {
    title: "projectValuation.ownerBuID",
    field: "OwnerBuIDDescription",
    width: 200
  },
  {
    title: "projectValuation.historyLastEntry",
    field: "HistoryLastEntry",
    type: "date",
    width: 200
  },
  {
    title: "projectValuation.modifiedByUserID",
    field: "ModifiedByUserIDDescription",
    width: 200
  },
  {
    title: "projectValuation.modifiedBuID",
    field: "ModifiedBuIDDescription",
    width: 200
  },
  {
    title: "projectValuation.recordStatusId",
    field: "RecordStatusIdDescription",
    width: 200
  },
  {
    title: "projectValuation.instructionDate",
    field: "InstructionDate",
    type: "date",
    width: 200
  },
  {
    title: "projectValuation.signedAndReceivedOn",
    field: "SignedAndReceivedOn",
    type: "date",
    width: 200
  },
  {
    title: "projectValuation.reference",
    field: "Reference",
    width: 200
  },
  {
    title: "projectValuation.signedBy",
    field: "SignedBy",
    width: 200
  },
  {
    title: "projectValuation.derivations",
    field: "Derivations",
    width: 200
  },
  {
    title: "projectValuation.derivationsFromInstructionLetter",
    field: "DerivationsFromInstructionLetterDescription",
    width: 200
  },
  {
    title: "projectValuation.valuationStatus",
    field: "ValuationStatusDescription",
    width: 200
  },
  {
    title: "projectValuation.client",
    field: "Client",
    width: 200
  }
];
